<div [ngStyle]="{'height': '100%'}" [ngClass]="'mb-12 flex justify-center items-center flex-col pb-12 mat-typography'" [style.marginTop]="mobile ? '0' : '10px'">

  <span
    *ngIf="cardSvgEl"
    [innerHTML]="cardSvgEl"
    id-="card_svg_element"
    class="generic-border-radius"
    [style.marginBottom]="mobile ? '0' : '32px'"
  >
  </span>

  <div class="bg-gray-300 flex flex-col justify-center items-center" [ngStyle]="{ 'padding': mobile ? '18%' : '1.5rem 10rem 1.5rem 10rem' }" style="border-radius: 12px">
    <mat-spinner
      class="loading-spinner mb-4"
      color="primary"
      diameter="75"
    >
    </mat-spinner>
    <span *ngIf="!tdsAuthed">Confirming 3D Secure Status</span>
    <span *ngIf="tdsAuthed">Authorising Transaction</span>
  </div>
</div>
